// required polyfills
// is used in modal.js import 'core-js/features/object/assign';
import 'core-js/features/string/repeat';
import 'core-js/features/string/pad-start';
import 'core-js/features/string/pad-end';
import 'core-js/features/global-this';
import IMask from "imask/esm/imask";
import 'imask/esm/masked/pattern';
import 'imask/esm/masked/dynamic';
const instances = [];
export function maskInput(element, options) {
    if (element.dataset.masked !== undefined) {
        return instances[element.dataset.masked];
    }
    const mask = IMask(element, options);
    instances.push(mask);
    element.dataset.masked = (instances.length - 1).toString();
    element.addEventListener('blur', function () {
        fixValue(this, mask);
    });
    fixValue(element, mask);
    return mask;
}
export function fixValue(element, mask) {
    if (typeof element.value !== 'string') {
        return;
    }
    if (element.value.match(/^\+7[ ()_-]*$/)) {
        mask.value = '';
    }
    if (element.value.match(/^8/)) {
        mask.value = element.value.replace(/^8/, '+7');
    }
}
export function maskPhoneInput(element, options) {
    return maskInput(element, Object.assign({ mask: [
            {
                mask: '+7 (000) 000-00-00',
                startsWith: /^(\+?7|9)/,
                pattern: '\\+7 *\\(?[0-9]{3}\\)? *([0-9]-?){7}',
            },
            {
                mask: '8 (000) 000-00-00',
                startsWith: '8',
                pattern: '8 *\\(?[0-9]{3}\\)? *([0-9]-?){7}',
            },
            {
                mask: '+1 (000) 000-0000',
                startsWith: '1',
                pattern: '\\+1 *\\(?[0-9]{3}\\)? *([0-9]-?){7}',
            },
            {
                mask: '+00 0000[0][0][0][0][0][0][0][0][0]',
                startsWith: /^\+?(9[80-5]|8[6421]|6[0-5]|5[1-8]|4[3-801]|3[0-469]|2[70])/,
                pattern: '\\+[0-9]{2} [0-9]{4,13}',
            },
            {
                mask: '+000 0000[0][0][0][0][0][0][0][0]',
                startsWith: /(^\+\d|\d|\+)/,
                pattern: '\\+[0-9]{3} [0-9]{4,12}',
            }
        ], dispatch: function (appended, dynamicMasked) {
            const number = (dynamicMasked.value + appended).replace(/\D/g, '');
            const plusNumber = ((dynamicMasked.value + appended)[0] === '+' ? '+' : '') + number;
            if (!number && (dynamicMasked.value + appended) !== '+') {
                return;
            }
            return dynamicMasked.compiledMasks.find(function (m) {
                const isMatch = typeof m.startsWith === 'string' ? number.indexOf(m.startsWith) === 0 : plusNumber.match(m.startsWith);
                if (isMatch && m.pattern !== element.pattern) {
                    element.pattern = m.pattern;
                }
                return isMatch;
            });
        } }, options));
}
